import { render, staticRenderFns } from "./add-signatures-loader.vue?vue&type=template&id=7a4d4d02"
import script from "./add-signatures-loader.vue?vue&type=script&lang=js"
export * from "./add-signatures-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports